import React from 'react';
import { RecentSearches } from '../RecentSearches';
import { HistoricalSearchDialog } from '../HistoricalSearchDialog';

interface HistoricalSearchViewerProps {
  showHistoricalSearchDialog: boolean;
  historicalSearchData: any;
  selectedHistoricalSearch: number | null;
  onViewResults: (searchId: number) => Promise<void>;
  onCloseDialog: () => void;
}

export const HistoricalSearchViewer: React.FC<HistoricalSearchViewerProps> = ({
  showHistoricalSearchDialog,
  historicalSearchData,
  selectedHistoricalSearch,
  onViewResults,
  onCloseDialog
}) => {
  return (
    <div className="mt-4">
      {/* Historical Search Results Dialog */}
      {showHistoricalSearchDialog && historicalSearchData && (
        <HistoricalSearchDialog 
          searchData={historicalSearchData}
          onClose={onCloseDialog}
        />
      )}
      
      <h2 className="text-xl font-bold mb-4 text-[#CECFD2]">Search History</h2>
      <RecentSearches 
        showPlayerImage={true}
        maxItems={10}
        onViewResults={onViewResults}
        title="Your Search History"
        className="bg-[#121212] rounded-lg shadow-lg border border-gray-700 p-4"
      />
    </div>
  );
};